(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-ProTeam"] && !window.DesignMode) return;
  try {
    

$(document).ready(function(){
  $('.block_slide').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrow: false,
    autoplay: true,
    autoplaySpeed: 6000,
  });
});

$(document).ready(function(){
  $('.colmn.img_col').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrow: false,
    autoplay: true,
    autoplaySpeed: 2000,
    draggable: false,
    swipe: false,
    touchMove: false
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-review-section"] && !window.DesignMode) return;
  try {
    
  $('.review_sli_block').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 3,
    dots: true,
    arrow:false,
    // variableWidth:true
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  $(document).ready(function(){
    $("collection-filters-form .filter-group details").attr("open","ture");
    $(".filter-group__body").css("height","auto");
    $(".filter-group__content").toggleClass("alreadyshow");
    $(".filter-group__heading svg.icon.icon-plus").addClass("hide_icon");
    $(".filter-group__heading svg.icon.icon-minus").addClass("show_icon");
    $("summary.filter-group__heading").click(function(){
      $(this).find(" svg.icon.icon-plus").removeClass("hide_icon");
      $(this).find(" svg.icon.icon-minus").removeClass("show_icon");
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_collection_tab"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.slider-show-div').first().addClass('active_argolf');
     $('.collection_buttons').first().addClass('active_argolf_buttons');
    $('.collection_buttons ').click(function(){
      $('.feature-collection-ul').slick('refresh');
      var cln_btn_id = $(this).attr('btn-id');
          $('.collection_buttons ').removeClass('active_argolf_buttons');
          $(this).addClass('active_argolf_buttons');
          $('.slider-show-div').each(function(){
            var product_btn_id =$(this).find('.slider-mobile-gutter').attr('btn-id');
                 if(product_btn_id == cln_btn_id){
                   $(this).show();
                 }
              else{
                   $(this).hide();
              }
          });
    });
  });
  $('.feature-collection-ul').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots:false,
  arrows:true,
  responsive: [
      {
        breakpoint: 1040,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-features"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $(".head").click(function(){
      $(this).next().slideToggle();
      $(this).find("svg").toggleClass("rotate_up");
      $(this).find(".countstroke").toggleClass("colored");
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  
  $(document).ready(function(){
    if($(window).width() < 767){
      $('.slider-for').remove();
      $('.slider-nav').remove();
  }
if($(window).width() > 767){
     $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none"><path d="M13 24.5L1 12.5L13 0.5" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="25" viewBox="0 0 14 25" fill="none"><path d="M1 24.5L13 12.5L1 0.5" stroke="#3F434A" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    fade: true,
    asNavFor: '.slider-nav',
            adaptiveHeight: true
  });    
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrow:false,
    centerMode: true,
    focusOnSelect: true
  });
}
    $("h2.accor_heading:first span svg").addClass("rotate_accor");
    $(".descript_accor:first").addClass("show_accor_content");
    

  });

  $(document).on("click", "h2.accor_heading", function() {
    var head_id = $(this).attr("head-id");
    $(".descript_accor").each(function() {
        var descript_id = $(this).attr("descript-id");
        if (descript_id == head_id) {
            $(this).toggleClass("show_accor_content");
          $(this).prev().find("svg.feather").toggleClass("rotate_accor");
        }
      else{
          $(this).removeClass("show_accor_content");
          $(this).prev().find("svg.feather").removeClass("rotate_accor");
      }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review_testimonial_cstm"] && !window.DesignMode) return;
  try {
    
  $('.reviews_about_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrow:false,
    // variableWidth:true
    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="#fff" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Previous" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="#fff" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrow:false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
         dots: true,
        arrow:false
      }
    }
  ]
    
});
  
  } catch(e) { console.error(e); }
})();
})();
